import {newStepValue} from '../../../../services/flowBuilder/utils/constants';

export const contactSending = {
    json: {
        menu: {
            menuType: 'contactSending',
            menuParams: {
                contact: {
                    name: {
                        firstname: '',
                        lastname: '',
                        formattedname: '',
                    },
                    addresses: {},
                    org: {
                        title:'',
                        department: '',
                        company: '',
                    },
                    urls: {},
                    emails: {},
                    phones: {},
                    birthdays: '',
                },
                addNewField: '',
                direction: 'outbound'
            }
        },
        type: 'menu',
        next: newStepValue,
    },
    paths: [
        'menu.menuParams.firstname',
        'menu.menuParams.lastname',
        'menu.MenuParams.formattedname',
        'menu.MenuParams.addresses',
        'menu.MenuParams.org',
        'menu.MenuParams.urls',
        'menu.MenuParams.emails',
        'menu.MenuParams.phones',
        'menu.MenuParams.birthdays',
        'menu.sendingParams.addNewField',
        'next',
    ],
    groups: [
        {
            Parameters: [
                'menu.menuParams.firstname',
                'menu.menuParams.lastname',
                'menu.menuParams.formattedname',
                'menu.MenuParams.addresses',
                'menu.MenuParams.org',
                'menu.MenuParams.urls',
                'menu.MenuParams.emails',
                'menu.MenuParams.phones',
                'menu.MenuParams.birthdays',
                'menu.menuParams.addNewField',
            ],
        },
        {
            Logic: ['next'],
        },
    ],
};
